import _ from 'lodash';
import {
  useEffect,
  useState
} from 'react';

import { useReactiveVar } from '@apollo/client';
import {
  Box,
  Typography
} from '@mui/material';
import { reactiveVariables } from 'modules/common';

import loaderGif from 'assets/loader.gif';



export type LoadingOverlayProps = {};

export const FC = (props: LoadingOverlayProps) => {
  const isLoading = useReactiveVar(reactiveVariables.showLoadingOverlay);
  const [
    selectedText,
    setSelectedText
  ] = useState(statements[_.random(0, statements.length)]);

  useEffect(() => {
    if (!isLoading) {
      return;
    }
    const timer = setInterval(() => {
      setSelectedText(statements[_.random(0, statements.length)]);
    }, 5000);

    return () => clearInterval(timer);
  }, [isLoading]);

  if (!isLoading) {
    return null;
  }

  return (
    <Box sx={{
      position: 'fixed',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      zIndex: 1000,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      userSelect: 'none'
    }}
    >
      <Box
        className='shadow-loader'
      >
        <Box
          component='img'
          src={loaderGif}
        />

        <Typography
          variant='h4'
          sx={{
            color: 'white',
            maxWidth: '300px'
          }}
        >
          {selectedText}
        </Typography>
      </Box>
    </Box>
  );
};



const statements = [
  'Analyzing complex market data to customize your insights...',
  'Gathering intricate financial patterns for accuracy...',
  'Processing real-time financial fluctuations...',
  'Consolidating data from global markets...',
  'Piecing together valuable fiscal puzzles...',
  'Parsing historical trends and future forecasts...',
  'Applying advanced algorithms to refine your data...',
  'Diving deep into the financial ocean for clarity...',
  'Extracting meaningful insights from raw numbers...',
  'Interpreting vast datasets for detailed information...',
  'Mining data for precision in financial strategies...',
  'Connecting dots between diverse data sources...',
  'Synthesizing complex financial variables...',
  'Generating dynamic insights tailored to you...',
  'Compiling unique financial trends for analysis...',
  'Decoding market movements for key insights...',
  'Filtering noise to deliver clear, concise data...',
  'Fine-tuning algorithms for personalized insights...',
  'Mapping out detailed financial landscapes...',
  'Aggregating multiple data streams in real-time...',
  'Creating a comprehensive view of market dynamics...',
  'Unearthing trends hidden beneath the data...',
  'Translating intricate data into actionable intelligence...',
  'Formulating strategies based on rich data points...',
  'Navigating through layers of financial information...',
  'Merging historical data with cutting-edge analytics...',
  'Scanning databases for critical market indicators...',
  'Configuring personalized financial profiles...',
  'Balancing complex computations for simplicity...',
  'Harnessing the power of data for informed decisions...',
  'Weaving data threads into a tapestry of insight...',
  'Capturing dynamic market shifts as they happen...',
  'Unpacking the foundations of financial data...',
  'Aligning various data metrics for coherence...',
  'Utilizing AI to streamline financial analysis...',
  'Fusing data science with market expertise...',
  'Refreshing your data with the latest updates...',
  'Transforming raw data into strategic recommendations...',
  'Crystalizing patterns from intricate datasets...',
  'Identifying key financial indicators for your benefit...',
  'Refining datasets to unveil critical intelligence...',
  'Diagnosing financial landscapes for sharp insights...',
  'Leveraging cloud technology for rapid analytics...',
  'Distilling data into understandable nuggets...',
  'Building a framework of financial understanding...',
  'Joining fragmented data into cohesive insights...',
  'Channeling raw financial data into structured reports...',
  'Aligning data trends with your financial goals...',
  'Structuring complex data into actionable formats...',
  'Revolutionary analytics working for your business...',
  'Integrating global datasets for a holistic view...',
  'Delving into micro and macroeconomic factors...',
  'Applying statistical models for enhanced clarity...',
  'Scrutinizing data points for precision forecasting...',
  'Customizing financial reports based on your criteria...',
  'Illuminating complex data through visualization...',
  'Constructing models to simulate market scenarios...',
  'Collating information from diverse economies...',
  'Uniting data from financial titans worldwide...',
  'Digging deep into financial metrics for excellence...',
  'Synchronizing massive datasets in milliseconds...',
  'Collaborating with AI to elevate data insights...',
  'Exploring financial ecosystems for potential gains...',
  'Concatenating multiple data formats into one...',
  'Harnessing big data for big decisions...',
  'Innovating with smart data solutions...',
  'Structuring analytical pipelines for efficiency...',
  'Tailoring data sets to reflect your needs...',
  'Redefining complexities in simple terms...',
  'Identifying outliers to strengthen data integrity...',
  'Addressing information gaps with precision tools...',
  'Configuring data profiles for maximum relevance...',
  'Tracing financial trajectories for strategic planning...',
  'Monitoring fluctuations with cutting-edge tech...',
  'Synchronizing your data with ongoing shifts...',
  'Maximizing data utility for robust performance...',
  'Sharpening fiscal foresight with curated data...',
  'Eradicating ambiguities from financial models...',
  'Generating comprehensive analytics on demand...',
  'Innovating beyond traditional financial analytics...',
  'Gathering insights from volatile market tides...',
  'Navigating complexities with precision analytics...',
  'Pioneering with data to forecast market trends...',
  'Integrating insights for holistic analytics...',
  'Customizing your financial dashboard in real-time...',
  'Reinforcing data security during compilation...',
  'Projecting future gains from historical metrics...',
  'Enlightening your financial path with data...',
  'Directing attention to critical fiscal insights...',
  'Activating smart data processing techniques...',
  'Curating contextual data for your business needs...',
  'Orchestrating data symphonies for unique insights...',
  'Translating numbers into narratives...',
  'Ensuring data accuracy and reliability...',
  'Advancing your financial knowledge through data...',
  'Empowering decisions with strategic data alignment...',
  'Orchestrating the rhythm of data for clarity...',
  'Clarifying complexities in real-time...',
  'Drawing impactful insights from vast datasets...',
  'Building financial acumen with data-driven insights...'
];
